import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import Footer from '../Shared/Footer';
import { SubTitleStyle, TextLinkStyle } from '../../styles/styles';
import { BREAKPOINTS, COLORS_BASE } from '../../utils/consts';
import SectionContainer from '../Shared/SectionContainer';


function About() {

    return (
        <>
            <SectionContainer backgroundColor={COLORS_BASE.GREYS.MAIN}>
                <ContentBlock>
                    <SubTitleStyle fontWeight='bold' margin='0 0 20px 0'> About the portal </SubTitleStyle>
                    <AboutTextStyle>
                        The Lesotho Electrification Portal has been developed with support from Renewable Lesotho, a collaboration between the&nbsp;
                        <TextLinkStyle href='https://www.gov.ls/'>Government of Lesotho</TextLinkStyle>, the&nbsp;
                        <TextLinkStyle href='https://www.eeas.europa.eu/delegations/lesotho_en?s=103'>European Union</TextLinkStyle> and development partners. It forms part of the European Union‘s&nbsp;
                        <TextLinkStyle href='https://commission.europa.eu/strategy-and-policy/priorities-2019-2024/stronger-europe-world/global-gateway_en'>Global Gateway</TextLinkStyle> initiative and is delivered in partnership with&nbsp;
                        <TextLinkStyle href='https://www.get-transform.eu/'>GET.transform</TextLinkStyle> and&nbsp;
                        <TextLinkStyle href='https://www.get-invest.eu/'>GET.invest</TextLinkStyle>.
                    </AboutTextStyle>
                </ContentBlock>
            </SectionContainer>
            <SectionContainer backgroundColor='#fff'>
                <RowBlock>
                    <GetTransformStyle src='/logos/logo-doe.png' alt="Lesotho Department of Energy logo" />
                    <TextBlock>
                        <SubTitleStyle fontWeight='bold' margin='0 0 20px 0'> The Department of Energy (DoE) </SubTitleStyle>
                        <AboutTextStyle>
                            <TextLinkStyle href='https://www.doe.gov.ls/'>The Department of Energy (DoE)</TextLinkStyle> forms part of Lesotho’s&nbsp;
                            <TextLinkStyle href='https://www.gov.ls/ministry-of-energy/'>Ministry of Natural Resources (MNR)</TextLinkStyle>
                            , working towards an enabling environment for efficient and effective energy services delivery to enhance access, affordability and ultimately socio-economic development. Together with the Ministry, the DoE is responsible for policy formulation, specifying policy goals and targets, and the implementation as well as coordination of the policies and sector plans. 
                        </AboutTextStyle>
                    </TextBlock>
                </RowBlock>
            </SectionContainer>
            <SectionContainer backgroundColor={COLORS_BASE.GREYS.MAIN}>
                <ContentBlock>
                    <SubTitleStyle fontWeight='bold' margin='0 0 20px 0'> 
                        Renewable Lesotho
                    </SubTitleStyle>
                    <AboutTextStyle>
                        <TextLinkStyle href='https://www.eeas.europa.eu/delegations/lesotho/renewable-lesotho_en'>Renewable Lesotho</TextLinkStyle> is a joint effort between the&nbsp;
                        <TextLinkStyle href='https://www.gov.ls/'>Government of Lesotho</TextLinkStyle> and its relevant Ministries, the&nbsp;
                        <TextLinkStyle href='https://www.eeas.europa.eu/delegations/lesotho_en?s=103'>European Union Delegation to Lesotho</TextLinkStyle>, the&nbsp;
                        <TextLinkStyle href='https://www.eib.org/en/index'>European Investment Bank (EIB)</TextLinkStyle>, European multi-donor platforms&nbsp;
                        <TextLinkStyle href='https://www.get-transform.eu/'>GET.transform</TextLinkStyle> and&nbsp;
                        <TextLinkStyle href='https://www.get-invest.eu/'>GET.invest</TextLinkStyle>, the&nbsp;
                        <TextLinkStyle href='https://edfi.eu/'>Association of Bilateral European Development Finance Institutions (EDFI)</TextLinkStyle>, the&nbsp;
                        <TextLinkStyle href='https://www.bmz.de/en'>German Federal Ministry for Economic Cooperation and Development (BMZ)</TextLinkStyle>,&nbsp;
                        <TextLinkStyle href='https://www.giz.de/en/html/index.html'>Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ)</TextLinkStyle> and the&nbsp;
                        <TextLinkStyle href='https://www.undp.org/'>United Nations Development Programme (UNDP)</TextLinkStyle>. Renewable Lesotho is aligned with the Sustainable Development Goals (SDGs) and particularly SDG 7 (Affordable and Clean Energy) as well as the Government of Lesotho’s National Strategic Development Plan II (NSDP II), the EU-Lesotho cooperation strategy for 2021-2027 and Team Europe Initiative – Green Deal. 
                    </AboutTextStyle>
                </ContentBlock>
            </SectionContainer>
            <SectionContainer backgroundColor='#fff'>
                <RowBlock>
                    <GetTransformStyle src='/logos/GETtransform-short-logo-w-EU-flag.png' alt="Get Transform logo with the EU flag" />
                    <TextBlock>
                        <SubTitleStyle fontWeight='bold' margin='0 0 20px 0'> 
                            GET.transform
                        </SubTitleStyle>
                        <AboutTextStyle>
                            <TextLinkStyle href='https://www.get-transform.eu/'>GET.transform</TextLinkStyle> is a technical assistance programme supporting national and regional partners and institutions in advancing their energy sector transformations. GET.transform is part of the European multi-donor platform Global Energy Transformation Programme (
                            <TextLinkStyle href='https://www.global-energy-transformation.eu/'>GET.pro</TextLinkStyle>), and co-funded by the European Union, Germany, Norway, the Netherlands, Sweden and Austria. 
                        </AboutTextStyle>
                    </TextBlock>
                </RowBlock>
            </SectionContainer>
            <Footer />
        </>
    )
}
export default About;

const ContentBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    width: 100%;
`;

const RowBlock = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 20px;
    width: 100%;

    @media (max-width: ${BREAKPOINTS.MOBILE}) {
      flex-direction: column;
      gap: 14px;
    }
`;

const TextBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    min-width: 0;
`;

export const AboutTextStyle = styled.p`
    justify-content: start;
    text-align: left;
    overflow-wrap: anywhere;
`;

const GetTransformStyle = styled.img`
    width: 10rem;
    object-fit: contain;
    padding: 1rem 1rem 0rem 2rem;

    @media (max-width: ${BREAKPOINTS.MOBILE}) {
      width: clamp(7rem, 38vw, 10rem);
      padding: 0;
    }
`

